<template>
  <div id="data-list-list-view">
    <!-- searchSheet -->
    <vx-card class="margin-bottom" title="筛选搜索"  noShadow cardBorder collapseAction>
      <vs-row vs-type="flex">
        <vs-col
          vs-order="1"
          vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
            <span>班级名称</span>
            <vs-input class="inline-block margin" v-model="searchSheetData.name"/>
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
            <span>创建时间</span>
            <!-- default -->
            <flat-pickr
              v-model="searchSheetData.beginDate"
              class="form-control margin" 
              :config="dateConfig"
              placeholder="开始时间">
            </flat-pickr>
            <!-- default -->
            <flat-pickr
              v-model="searchSheetData.endDate"
              class="form-control margin" 
              :config="dateConfig"
              placeholder="结束时间">
            </flat-pickr>
        </vs-col>
      </vs-row>
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vs-button class="margin" color="primary" type="filled" @click="requestSearch">搜索</vs-button>
        <vs-button class="margin" color="warning" type="border" @click="resetSearch">重置</vs-button>
      </div>
    </vx-card>

    <!-- classList -->
    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="list" :hoverFlat="true">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ADD NEW -->
        <div class="flex">
          <vs-button class="rounded-full mr-4 p-2" color="primary" icon-pack="feather" icon="icon-refresh-cw" @click="init"></vs-button>
          <vs-button class="rounded-full px-3 py-2" color="primary" type="border" icon-pack="feather" icon="icon-plus" @click="addClassPrompt = true">新建班级</vs-button>
        </div>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mr-4">
          <div class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                list.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : list.length
              }}
              of {{ list.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <template slot="thead">
        <vs-th>序号</vs-th>
        <vs-th sort-key="name">班级</vs-th>
        <vs-th sort-key="student_num">学生数量</vs-th>
        <vs-th sort-key="create_time">创建时间</vs-th>
        <vs-th>操作</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium">{{ indextr + 1 }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.name }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.student_num }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.create_time }}</p>
            </vs-td>
            <vs-td>
              <vs-button color="primary" size="small" type="filled" @click="viewClassStudent(tr)">查看</vs-button>
              <vs-button class="ml-4" color="success" size="small" type="filled" @click="showStudentPrompt(tr)">添加学生</vs-button>
              <vs-button class="ml-4" color="warning" size="small" type="filled" @click="showRemoveStudentPrompt(tr)">移除学生</vs-button>
              <vs-button class="ml-4" color="rgb(62, 201, 214)" size="small" type="filled" @click="goToReport(tr)">学期汇报</vs-button>
              <vs-button class="ml-4" color="danger" size="small" type="filled" @click="deleteClassroom(tr)">删除班级</vs-button>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <!-- createClassroomPrompt -->
    <vs-prompt
      vs-title="创建班级"
      vs-accept-text="确定"
      vs-cancel-text="取消"
      @vs-accept="addNewClass"
      @vs-cancel="closeAddPrompt"
      @vs-close="closeAddPrompt"
      :vs-active.sync="addClassPrompt"
    >
      <div class="con-exemple-prompt">
        <span>请输入班级名称</span>
        <vs-input v-model="newClassName" class="mt-3 w-full" />
      </div>
    </vs-prompt>

    <!-- StudentPrompt -->
    <vs-prompt
      vs-title="添加学生"
      :vs-buttons-hidden="true"
      :vs-active.sync="studentPrompt"
      @vs-close="closeStudentPrompt"
    >
      <div class="con-exemple-prompt">
        <div class="flex flex-col items-center my-4" v-if="!addStudentNextStep">
          <div class="w-1/2">
            <vs-radio
              class="mb-2"
              v-model="addStudentMode"
              vs-name="radios1"
              vs-value="0"
              >创建新的学生账号</vs-radio
            >
            <vs-radio v-model="addStudentMode" vs-name="radios1" vs-value="1"
              >添加已注册学生账号</vs-radio
            >
          </div>
          <div class="mt-3">
            <vs-button
              color="primary"
              size="small"
              type="filled"
              @click="addStudentNextStep = true"
              >下一步</vs-button
            >
          </div>
        </div>
        <div v-if="addStudentNextStep">
          <div v-if="addStudentMode == 0" class="flex flex-col items-center">
            <h3 class="text-center mt-2">创建新的学生账号</h3>
            <vs-textarea
              v-model="newStudents"
              placeholder="【提示】一个班创建学生不能超过100个，学生名字为纯汉字或纯英文，名字长度不大于20。
【示例】每行增加一个学生姓名。格式如下:
  何佩佩
  刘鹏鹏
  何子文
  Evan
  Jack"
              height="300"
            />
            <vs-button color="primary" size="small" type="filled" @click="addNewStudent"
              >确认</vs-button
            >
          </div>
          <div v-if="addStudentMode == 1" class="flex flex-col items-center">
            <h3 class="text-center mt-2">添加已注册学生账号</h3>
            <vs-textarea
            v-model="newStudents"
              placeholder="一次最多可以添加200个学生账号，
请填写学生的用户名：

每行输入一个学生用户名，格式如下：
1005838009
1006778001
1006778002
25422011360016
25422011360018
edu1006778001
edu1006778002"
              height="300"
            />
            <vs-button color="primary" size="small" type="filled" @click="addNewStudent"
              >确认</vs-button
            >
          </div>
        </div>
      </div>
    </vs-prompt>

    <!-- removeStudentPrompt -->
    <vs-prompt
      :vs-title="rowClassName"
      :vs-buttons-hidden="true"
      :vs-active.sync="removeStudentPrompt"
      @vs-close="closeRemoveStudentPrompt"
    >
      <div class="con-exemple-prompt">
        <div class="flex flex-col items-center my-4">
          <vs-table search multiple v-model="selectedRemoveStudent" :data="studentList" maxHeight="450px">
            <template slot="header">
              <h3>
                学生列表
              </h3>
            </template>
            <template slot="thead">
              <vs-th sort-key="name">
                姓名
              </vs-th>
              <vs-th sort-key="username">
                用户名
              </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>
                <vs-td :data="data[indextr].username">
                  {{ data[indextr].user.username }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <p class="tips">建议将学生添加至新的班级后再在原班级中移除学生</p>
          <div class="mt-3">
            <vs-button color="primary" size="small" type="filled" @click="removeStudent" >移除学生</vs-button>
          </div>
        </div>
      </div>
    </vs-prompt>

    <!-- deleteClassroomPrompt -->
    <vs-prompt
      vs-title="删除班级"
      :vs-buttons-hidden="true"
      :vs-active.sync="deletePrompt"
      @vs-close="closeDeleteClassroomPrompt"
    >
      <div class="con-exemple-prompt">
        <div class="flex flex-col items-center my-4">
          <p>班级学生必须为空，请将学生移至其他班级。</p>
          <div class="mt-3">
            <vs-button color="primary" size="small" type="filled" @click="closeDeleteClassroomPrompt" >确定</vs-button>
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>

import axios from 'axios'
import { classList, addClass, delClass, addStudents, studentList, removeStudentsFromClass } from "@/api/school";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Mandarin } from 'flatpickr/dist/l10n/zh.js';

export default {
  components: {
    flatPickr
  },
  data() {
    return {
      list: [],
      selectedRemoveStudent: [],
      searchSheetData: {
        name: "",
        beginDate: null,
        endDate: null
      },
      dateConfig: {
        dateFormat: "Y-m-d H:i",	//data变成时间戳
        altFormat: 'Y-m-d H:i',	      //选择时显示的时间
        enableTime:true,			//选择小时分种
        defaultHour: 8,			  //默认8点
        time_24hr: true,			//时间24小时制
        locale: Mandarin	
      },
      studentList:[
      {
        "id": 1,
        "name": "张三",
        "user": {
          "username": "edu234124",
        }
      }],
      itemsPerPage: 5,
      isMounted: false,
      addClassPrompt: false,
      newClassName: "",
      rowClassName: "",
      studentPrompt: false,
      removeStudentPrompt: false,
      deletePrompt: false,
      addStudentMode: 0, // 0 创建新账号并添加 1 添加已有账号
      addStudentNextStep: false, // 下一步 ,
      promptSearchName: "", //班级学生用户搜索
      newStudents: '',
      currentClassId: 0,
    }
  },
  created() {},
  mounted() {
    this.isMounted = true;
    this.init();
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    init() {
      classList().then((res) => {
        if (res.code == 1) {
          this.list = res.data.list;
        }
      });
    },
    requestSearch() {
      classList(this.searchSheetData).then((res) => {
        if (res.code == 1) {
          this.list = res.data.list;
        }
      });
    },
    resetSearch() {
      this.searchSheetData = {
        name: "",
        beginDate: null,
        endDate: null
      };
      this.init();
    },
    addNewClass() {
      addClass({
        name: this.newClassName,
      }).then((res) => {
        if (res.code == 1) {
          this.$vs.notify({
            color: "success",
            text: "添加成功！",
            title: "提示",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          this.closeAddPrompt();
          this.init();
        }
      });
    },
    removeStudent() {
      let temp = [];
      temp = this.selectedRemoveStudent.map(item => {
        return item.id
      })
      removeStudentsFromClass({
        class_id: this.currentClassId,
        students: temp
      }).then(res => {
        if (res.code == 1) {
          this.init()
          this.$vs.notify({
            color: "success",
            text: "移除学生成功！",
            title: "提示",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          this.closeRemoveStudentPrompt()
        }
      })
    },
    deleteClassroom (row) {
      if (row.student_num != 0) {
        this.deletePrompt = true;
        return;
      }
      delClass({
        id: row.id
      }).then(res => {
        if (res.code == 1) {
          this.list.forEach((listItem,index) => {
            if (listItem.id == row.id) {
              this.list.splice(index, 1);
            }
          });
          this.$vs.notify({
            color: "success",
            text: "删除班级成功！",
            title: "提示",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        }
      })
    },
    closeAddPrompt() {
      this.addClassPrompt = false;
      this.newClassName = "";
    },
    showStudentPrompt (row){
      this.currentClassId = row.id
      this.addStudentMode = 0
      this.addStudentNextStep = false
      this.studentPrompt = true
      this.newStudents = ''
    },
    showRemoveStudentPrompt(row) {
      if (row.student_num == 0) {
        this.$vs.notify({
          color:'warning', 
          text: '该班级还没有学生',
          title: '提示',
          iconPack: 'feather',
          icon: 'icon-alert-circle'  
        })
        return;
      }
      this.currentClassId = row.id
      this.rowClassName = row.name
      this.removeStudentPrompt = true
      this.selectedRemoveStudent = []
      studentList({
        class_id: row.id
      }).then(res => {
        if (res.code == 1) {
          this.studentList = res.data.list
        }
      })
    },
    closeRemoveStudentPrompt() {
      this.removeStudentPrompt = false;
    },
    closeDeleteClassroomPrompt() {
      this.deletePrompt = false;
    },
    addNewStudent() {
      if (this.newStudents == '') {
        this.$vs.notify({
          color:'warning', 
          text: '学生列表不能为空',
          title: '提示',
          iconPack: 'feather',
          icon: 'icon-alert-circle'  
        })
        return false
      }
      addStudents({
        class_id: this.currentClassId,
        mode: this.addStudentMode,
        students: this.newStudents.replace(/\ +/g,""),
      }).then(res => {
        if (res.code == 1) {
          this.$vs.notify({
            color:'success', 
            text: '操作成功！',
            title: '提示',
            iconPack: 'feather',
            icon: 'icon-alert-circle'  
          })
          if (res.data.fileName != '' && res.data.path != '') {
            this.downloadExcel(res.data)
          }
          this.init()
        }
        this.closeStudentPrompt()
      })
    },
    closeStudentPrompt() {
      this.studentPrompt = false
      this.currentClassId = 0
    },
    downloadExcel(exc) {
      axios.get(exc.path, { responseType: 'blob'}).then(res => {
          if (!res.data) {
            this.$vs.notify({
              color:'error', 
              text: '下载失败',
              title: '提示',
              iconPack: 'feather',
              icon: 'icon-alert-circle'  
            })
            return
          }
          let url = window.URL.createObjectURL(new Blob([res.data]))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', exc.fileName)

          document.body.appendChild(link)
          link.click()
          // 释放资源及移除节点（用完就丢）
          window.URL.revokeObjectURL(url)
          document.body.removeChild(link)
      }).catch(err => {
          console.log('err:', err)
      })
    },
    deleteClass(row) {
      if (row.student_num == 0) {
        delClass({
          id: row.id
        }).then(res => {
          if (res.code == 1) {
            this.$vs.notify({
              color:'success', 
              text: '操作成功！',
              title: '提示',
              iconPack: 'feather',
              icon: 'icon-alert-circle'  
            })
            this.init()
          }
        })
      } else {
        this.$vs.notify({
          color:'warning', 
          text: '班级学生必须为空，请将学生移至其他班级',
          title: '提示',
          iconPack: 'feather',
          icon: 'icon-alert-circle'  
        })
      }
      
    },
    viewClassStudent(row) {
      this.$router.push({path: '/student/List', query: {id: row.id}})
    },
    goToReport(row) {
      this.$router.push({path: '/report/classReport', query: {classId: row.id, className: row.name}})
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/_variables.scss";

#data-list-list-view {
  white-space: nowrap;
}
.tips {
  font-size: $font-size-small;
  color: $danger;
}
.con-vs-dialog .vs-dialog {
  max-width: 450px;
}
.vs-con-table {
  margin-bottom: 20px;
}
.margin-bottom{
  margin-bottom: 20px;
}
.inline-block{
  display: inline-block;
}
.margin{
  margin: 0 0 0 1rem;
}
.vs-col{
  margin-bottom: 20px;
}
.vs-con-input-label{
  width: 100%;
}
</style>
